import { render, staticRenderFns } from "./PushZigZag.vue?vue&type=template&id=cc2b6fe8&"
import script from "./PushZigZag.vue?vue&type=script&lang=js&"
export * from "./PushZigZag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc2b6fe8')) {
      api.createRecord('cc2b6fe8', component.options)
    } else {
      api.reload('cc2b6fe8', component.options)
    }
    module.hot.accept("./PushZigZag.vue?vue&type=template&id=cc2b6fe8&", function () {
      api.rerender('cc2b6fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/fragments/mobile/PushZigZag.vue"
export default component.exports